
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.04.244A.466.466 0 009.63 0a.466.466 0 00-.411.244L6.502 5.338a.465.465 0 01-.334.238l-5.782.959a.461.461 0 00-.363.307.448.448 0 00.11.459l4.102 4.107a.449.449 0 01.127.385l-.856 5.686a.452.452 0 00.186.434c.14.1.324.115.479.04l5.252-2.556a.471.471 0 01.413 0l5.252 2.556c.155.075.34.06.479-.04a.45.45 0 00.186-.434l-.857-5.686a.449.449 0 01.128-.385L19.127 7.3a.448.448 0 00.11-.459.462.462 0 00-.364-.307l-5.782-.96a.465.465 0 01-.334-.237L10.04.244z","fill":"#172542"}})])
          )
        }
      }
    